var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('div',{staticClass:"message-wrap"},[_c('div',{staticClass:"message-wrap2"},[_c('div',{staticClass:"white-wrap",style:({
					height: _vm.myHeight,
					width: _vm.myWidth,
					overflow: _vm.overflow,
					'background-color': _vm.bg,
				})},[_vm._t("content")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }